const borders = {
  0: 0,
  1: '1px solid',
  2: '2px solid',
  3: '4px solid',
  4: '8px solid',
  dotted: '1px dotted',
};

export default borders;
